import React, { useContext } from 'react';
import { UserContext } from './App';
import { FaCrown, FaTicketAlt } from 'react-icons/fa';

export default function Rewards() {
    const { user } = useContext(UserContext);

    return (
        <div style={{ padding: '40px 20px', minHeight: '100%', background: '#0f1115', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            
            {/* Header Text */}
            <div style={{ textAlign: 'center', marginBottom: '20px', zIndex: 2 }}>
                <div style={{ fontSize: '14px', color: '#9ca3af', fontWeight: 600 }}>
                    Welcome <span style={{ color: '#fff', fontWeight: 800 }}>{user?.username || 'user'}</span> to
                </div>
                <div style={{ fontSize: '64px', fontWeight: 900, color: '#ffb703', fontStyle: 'italic', letterSpacing: '-2px', lineHeight: 1.1, textShadow: '0 4px 20px rgba(255, 183, 3, 0.2)' }}>
                    REWARDS
                </div>
            </div>

            {/* Giant Crown Graphic Area */}
            <div style={{ position: 'relative', height: '300px', width: '100%', maxWidth: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '300px', height: '300px', background: 'radial-gradient(circle, rgba(255, 183, 3, 0.15) 0%, rgba(15,17,21,0) 70%)', zIndex: 1 }} />
                <FaCrown size={180} color="#ffb703" style={{ zIndex: 3, filter: 'drop-shadow(0 20px 30px rgba(0,0,0,0.8))' }} />
            </div>

            {/* User Profile Summary */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '40px', zIndex: 2 }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#1a1c22', overflow: 'hidden', border: '2px solid #2d3748', marginBottom: '12px' }}>
                    <img src={user?.avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user?.username}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ fontSize: '16px', fontWeight: 900 }}>{user?.username || 'user'}</div>
                <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: 800 }}>LEVEL {user?.level?.current || 1}</div>
            </div>

            {/* Progress Bar */}
            <div style={{ width: '100%', maxWidth: '800px', marginBottom: '60px', zIndex: 2 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '12px', color: '#9ca3af', fontWeight: 700 }}>Current level:</span>
                        <span style={{ background: '#2d3748', color: '#9ca3af', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 800, fontStyle: 'italic' }}>{user?.level?.current || 1}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#fff', fontWeight: 800 }}>
                        {Math.floor(user?.level?.progress || 0)} <span style={{ color: '#9ca3af' }}>/ 100 XP</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '12px', color: '#9ca3af', fontWeight: 700 }}>Next level:</span>
                        <span style={{ background: '#2d3748', color: '#9ca3af', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 800, fontStyle: 'italic' }}>{(user?.level?.current || 1) + 1}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: '16px', background: '#1a1c22', borderRadius: '8px', overflow: 'hidden', border: '1px solid #2d3748' }}>
                    <div style={{ width: `${user?.level?.progress || 0}%`, height: '100%', background: '#ffb703' }} />
                </div>
            </div>

            {/* Weekly / Monthly Bonuses Card */}
            <div style={{ width: '100%', maxWidth: '800px', background: 'linear-gradient(90deg, #16191f 0%, #1a1c22 100%)', borderRadius: '16px', padding: '32px', position: 'relative', overflow: 'hidden', border: '1px solid #2d3748', zIndex: 2 }}>
                <div style={{ position: 'relative', zIndex: 2, maxWidth: '100%' }}>
                    <div style={{ fontSize: '24px', fontWeight: 900, color: '#fff', marginBottom: '8px', textTransform: 'uppercase', fontStyle: 'italic', letterSpacing: '-0.5px' }}>
                        WEEKLY / MONTHLY BONUSES
                    </div>
                    <div style={{ fontSize: '13px', color: '#9ca3af', lineHeight: 1.5, fontWeight: 600 }}>
                        Our <span style={{ color: '#fff', fontWeight: 800 }}>VIP Program</span> rewards players with <span style={{ color: '#ffb703', fontWeight: 800 }}>exclusive benefits</span> the more they play and wager on the site.
                    </div>
                </div>
            </div>

        </div>
    );
}
